<template>

  <div class="row">
    <div class="col-md-4 hidden-sm hidden-xs">
      <div class="hpanel panel-group" style="height: 450px;overflow-x: auto">
        <div id="notes" class="collapse" v-if="question !== null && question.solutions.length !== 0" >

          <div class="panel-body note-link" :class="solutionSelected.id === solution.id ? 'active' : ''" v-for="(solution, key) in question.solutions" :key="key" @click="changeSolution(solution)">
            <div class="pull-right" style="margin-left: 5px">
              <div>
                <small class="text-muted">{{solution.updated_at | moment('LLL')}}</small>
              </div>

              <div v-if="solution.status === 0" class="label label-warning pull-right" style="margin-top: 5px">To be reviewed</div>
              <div v-else-if="solution.status === 1" class="label label-success pull-right" style="margin-top: 5px"><i class="fa fa-thumbs-o-up"></i> Interested</div>
              <div v-else-if="solution.status === 2" class="label label-danger pull-right" style="margin-top: 5px"><i class="fa fa-thumbs-o-down"></i> Not interested</div>
            </div>
            <h5>{{solution.title}}</h5>
            <div>
              <small class="text-muted">{{solution.user.firstname}} {{solution.user.lastname}}</small>
            </div>
          </div>
        </div>
        <div v-else class="text-center vertical-mid" style="width: 100%;height: 100%">
          <div>No response yet</div>
        </div>

      </div>
    </div>
    <div class="col-xs-12 hidden-md hidden-lg" style="margin-bottom: 15px">
      <div class="col-xs-12">
        <button type="button" data-toggle="collapse" data-target="#notes2" class="btn-sm visible-xs visible-sm btn-default btn btn-block m-t-sm" aria-expanded="true">
          All proposals <i class="fa fa-angle-down"></i>
        </button>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div id="notes2" class="collapse" aria-expanded="true" style="margin-top: 15px">

            <div class="panel-body note-link" :class="solutionSelected.id === solution.id ? 'active' : ''" v-for="(solution, key) in question.solutions" :key="key" @click="changeSolution(solution)">
              <div class="pull-right" style="margin-left: 5px">
                <div>
                  <small class="text-muted">{{solution.updated_at | moment('LLL')}}</small>
                </div>

                <div v-if="solution.status === 0" class="label label-warning pull-right" style="margin-top: 5px">To be reviewed</div>
                <div v-else-if="solution.status === 1" class="label label-success pull-right" style="margin-top: 5px"><i class="fa fa-thumbs-o-up"></i> Interested</div>
                <div v-else-if="solution.status === 2" class="label label-danger pull-right" style="margin-top: 5px"><i class="fa fa-thumbs-o-down"></i> Not interested</div>
              </div>
              <h5>{{solution.title}}</h5>
              <div>
                <small class="text-muted">{{solution.user.firstname}} {{solution.user.lastname}}</small>
              </div>
            </div>
            <!--<div v-else class="text-center vertical-mid" style="width: 100%;height: 100%">-->
            <!--<div>No expert proposal</div>-->
            <!--</div>-->

          </div>
        </div>
      </div>
    </div>
    <div class="col-md-8 col-xs-12">
      <div class="hpanel">

        <div class="panel-body" style="height: 450px">

          <div v-if="question === null || question.solutions.length === 0" class="text-center vertical-mid" style="width: 100%;height: 100%">
              <span>
                You may check your email inbox
              </span>
          </div>

          <div v-else class="tab-content" style="height: 100%">
            <div style="height: 100%" class="tab-pane" :class="solutionSelected.id === solution.id ? 'active' : ''" v-for="(solution, key) in question.solutions" :key="key">
              <div class="pull-right text-muted m-l-lg">
                {{solution.created_at | moment('LLL')}}
              </div>
              <div class="pull-right text-muted m-l-lg">
                <small class="text-muted">{{solution.user.firstname}} {{solution.user.lastname}}</small>
              </div>
              <h3>{{solution.title}}</h3>

              <hr>
              <div class="note-content" style="max-height: 215px;height: 100%;overflow-x: auto">
                <div v-html="solution.content" style="height: 100%"></div>
              </div>

              <div class="row" style="margin-top:10px;height: 40px;">
                <div v-for="(file, key) in solution.files" :key="key" class="col-xs-6">
                  <a :href="$apiUrl + file.filename" target="_blank">{{file.filename.match('.*\/(.*)')[1]}}</a>
                </div>
              </div>

              <div class="btn-group pull-right" style="margin-top: 15px">
                <button class="btn btn-sm btn-success" v-bind:disabled="solution.status === 1" @click="changeSolutionStatus(1)"><i class="fa fa-thumbs-o-up"></i> Interested</button>
                <button class="btn btn-sm btn-danger" v-bind:disabled="solution.status === 2" @click="changeSolutionStatus(2)"><i class="fa fa-thumbs-o-down"></i> Not interested</button>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>
<style scoped>
  .note-link.active {
    background-color: #f7f9fa;
  }
  .note-link {
    cursor: pointer;
  }

</style>
<script>
import VueLadda from 'vue-ladda'
import UploadFile from '../../components/question/UploadFile'

export default {
  components: {VueLadda, UploadFile},
  props: ['question'],
  name: 'SolutionConsultant',
  data () {
    return {
      submit: {
        loading: false,
        'dataStyle': ''
      },
      solutionSelected: null
    }
  },
  methods: {
    changeSolution: function (solution) {
      this.solutionSelected = solution
    },
    changeSolutionStatus: function (status) {
      this.axios.patch('/solution/' + this.solutionSelected.id + '/status/' + status)
        .then((response) => {
          this.getResources()
        }).catch(function (error) {
        })
    }
  },
  beforeMount () {
    if (this.question !== null && typeof this.question.solutions !== 'undefined' &&
        this.question.solutions.length !== 0) {
      this.solutionSelected = this.question.solutions[0]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chatSolution/SolutionConsultant.vue